<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <h5>SAP Equipment Logs</h5>
                            <div>
                                <button @click="exportAllExcel" class="btn btn-success btn-sm me-2">
                                    <i class="fas fa-file-excel"></i> Download
                                </button>
                                <router-link to="/sap_equipment/downloaded_reports" class="btn btn-info btn-sm me-2">
                                    <i class="fas fa-folder-open"></i> Downloaded Reports
                                </router-link>
                                <router-link to="/sap_reports" class="btn btn-secondary btn-sm">
                                    <i class="fas fa-arrow-left"></i> Back
                                </router-link>
                            </div>
                        </div>

                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-sm-3" v-if="isPlantWide">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">From Date</div>
                                        <input
                                            class="form-control"
                                            type="date"
                                            v-model="meta.from_date"
                                            :class="{ 'is-invalid': errors.from_date }"
                                        />
                                        <span v-if="errors.from_date" class="invalid-feedback">{{ errors.from_date[0] }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-3" v-if="isPlantWide">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">To Date *</div>
                                        <input
                                            class="form-control"
                                            type="date"
                                            v-model="meta.to_date"
                                            :class="{ 'is-invalid': errors.to_date }"
                                        />
                                        <span v-if="errors.to_date" class="invalid-feedback">{{ errors.to_date[0] }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-4" v-if="isPlantWide">
                                    <div class="input-group field-wrapper">
                                        <input
                                            class="form-control"
                                            type="text"
                                            placeholder="Type here and press enter to search"
                                            v-model="meta.search"
                                            @keyup.enter="search"
                                        />
                                        <span class="input-group-text">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-8" v-else>
                                    <div class="input-group field-wrapper">
                                        <input
                                            class="form-control"
                                            type="text"
                                            placeholder="Type here and press enter to search"
                                            v-model="meta.search"
                                            @keyup.enter="search"
                                        />
                                        <span class="input-group-text">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-2 mt-2">
                                    <button type="button" class="btn btn-primary" @click="search">Search</button>
                                </div>
                            </div>

                            <div class="table-responsive tabletop">
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Equipment Number</th>
                                            <th>Equipment Description</th>
                                            <th>Order Number</th>
                                            <th>Order Description</th>
                                            <th>Inspection Lot Number</th>
                                            <th>Inspection Operation No</th>
                                            <th>MIC</th>
                                            <th>Short Text Order</th>
                                            <th>Inspection Specification</th>
                                            <th>Inspection Result</th>
                                            <th>User Name</th>
                                            <th>System Date</th>
                                            <th>System Time</th>
                                            <th>Maintenance Plan</th>
                                            <th>Lower Limit</th>
                                            <th>Upper Limit</th>
                                            <th>Notification Flag</th>
                                            <th>System Status</th>
                                            <th>Maintenance Plant</th>
                                            <th>Order Type</th>
                                            <th>Plant Section</th>
                                            <th>Planner Group</th>
                                            <th>Maint Activity Type</th>
                                            <th>City Postal Code</th>
                                            <th>Street</th>
                                            <th>Remarks</th>
                                            <th>Uploaded By</th>
                                            <th class="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="sap_logs.length === 0">
                                            <td colspan="29" class="text-center py-4">No records found</td>
                                        </tr>

                                        <template
                                            v-for="(equipment, index) in sap_logs"
                                            :key="equipment.order_equipment_id"
                                        >
                                            <tr class="equipment-row">
                                                <td>{{ meta.from + index }}</td>
                                                <td>{{ equipment.equipment_number }}</td>
                                                <td>{{ equipment.equipment_desc }}</td>
                                                <td>{{ equipment.order_number }}</td>
                                                <td>{{ equipment.order_desc }}</td>
                                                <td>{{ equipment.inspection_lot_number }}</td>
                                                <td>{{ equipment.inpection_operation_no }}</td>
                                                <td>{{ displayValue(equipment.mic) }}</td>
                                                <td>{{ equipment.short_text_order }}</td>
                                                <td>{{ equipment.inspection_specification }}</td>
                                                <td>{{ equipment.inspection_result }}</td>
                                                <td>{{ equipment.user_name }}</td>
                                                <td>{{ equipment.system_date }}</td>
                                                <td>{{ equipment.system_time }}</td>
                                                <td>{{ equipment.maintenance_plan }}</td>
                                                <td>{{ equipment.lower_limit }}</td>
                                                <td>{{ equipment.upper_limit }}</td>
                                                <td>{{ equipment.notification_flag }}</td>
                                                <td>{{ equipment.system_status }}</td>
                                                <td>{{ equipment.maintenance_plant }}</td>
                                                <td>{{ equipment.order_type }}</td>
                                                <td>{{ equipment.plant_section }}</td>
                                                <td>{{ equipment.planner_group }}</td>
                                                <td>{{ equipment.maint_activity_type }}</td>
                                                <td>{{ equipment.city_postal_code }}</td>
                                                <td>{{ equipment.street }}</td>
                                                <td></td>
                                                <td></td>
                                                <td class="text-center">
                                                    <button
                                                        v-if="equipment.order_attachments && equipment.order_attachments.length > 0"
                                                        @click.stop="openAttachmentModal(equipment)"
                                                        class="btn btn-sm"
                                                        title="View Attachments"
                                                    >
                                                        <i class="fas fa-images"></i> ({{
                                                        equipment.order_attachments.length }})
                                                    </button>
                                                    <span v-else class="text-muted">-</span>
                                                </td>
                                            </tr>

                                            <tr
                                                v-for="(check, checkIndex) in equipment.order_checks"
                                                :key="check.order_check_id"
                                                class="check-row"
                                            >
                                                <td>{{ meta.from + index }}.{{ checkIndex + 1 }}</td>
                                                <td>{{ check.equipment_number }}</td>
                                                <td>{{ check.equipment_desc }}</td>
                                                <td>{{ check.order_number }}</td>
                                                <td>{{ check.order_desc }}</td>
                                                <td>{{ check.inspection_lot_number }}</td>
                                                <td>{{ check.inpection_operation_no }}</td>
                                                <td>{{ displayValue(check.mic) }}</td>
                                                <td>{{ check.short_text_order }}</td>
                                                <td>{{ check.inspection_specification }}</td>
                                                <td>{{ check.inspection_result }}</td>
                                                <td>{{ check.user_name }}</td>
                                                <td>{{ check.system_date }}</td>
                                                <td>{{ check.system_time }}</td>
                                                <td>{{ check.maintenance_plan }}</td>
                                                <td>{{ check.lower_limit }}</td>
                                                <td>{{ check.upper_limit }}</td>
                                                <td>{{ check.notification_flag }}</td>
                                                <td>{{ check.system_status }}</td>
                                                <td>{{ check.maintenance_plant }}</td>
                                                <td>{{ check.order_type }}</td>
                                                <td>{{ check.plant_section }}</td>
                                                <td>{{ check.planner_group }}</td>
                                                <td>{{ check.maint_activity_type }}</td>
                                                <td>{{ check.city_postal_code }}</td>
                                                <td>{{ check.street }}</td>
                                                <td>{{ check.remarks }}</td>
                                                <td>{{ getCheckUserName(check) }}</td>
                                                <td></td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                            <div class="form-actions-footer">
                                <div class="text-end row">
                                    <div class="col-sm-2">
                                        <select class="form-control" v-model="meta.per_page" @change="onPerPageChange">
                                            <option>10</option>
                                            <option>15</option>
                                            <option>20</option>
                                            <option>25</option>
                                            <option>30</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-10">
                                        <Pagination
                                            class="pagination pagination-sm"
                                            :maxPage="meta.maxPage"
                                            :totalPages="meta.lastPage"
                                            :currentPage="meta.currentPage"
                                            @pagechanged="onPageChange"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Attachments -->
        <div class="modal fade" id="attachmentModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Attachments - {{ selectedEquipmentTitle }}
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center overflow-scroll">
                        <div
                            v-if="hasNoAttachments"
                            class="py-5 text-muted"
                        >
                            No attachments found.
                        </div>
                        <div v-else class="row g-4">
                            <div
                                v-for="attachment in selectedEquipment.order_attachments"
                                :key="attachment.order_equipment_attachment_id"
                                class="col-md-3"
                            >
                                <img
                                    :src="attachment.attachment_url"
                                    class="img-fluid rounded shadow"
                                    style="max-height: 300px; object-fit: contain; cursor: pointer"
                                    @click="openImageInNewTab(attachment.attachment_url)"
                                    :alt="attachment.file_name"
                                />
                                <small class="d-block mt-2 text-muted">{{ attachment.file_name }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Pagination from "@/components/Pagination.vue";
    import { Modal } from "bootstrap";

    export default {
        components: { Pagination },
        data() {
            let orderId = null;
            if (this.$route.params.order_id) {
                orderId = this.$route.params.order_id;
            }
            let today = new Date();
            let year = today.getFullYear();
            let month = today.getMonth() + 1;
            let day = today.getDate();
            let monthText = "" + month;
            if (month < 10) {
                monthText = "0" + month;
            }
            let dayText = "" + day;
            if (day < 10) {
                dayText = "0" + day;
            }
            let currentDate = year + "-" + monthText + "-" + dayText;
            return {
                sap_logs: [],
                selectedEquipment: null,
                errors: {},
                meta: {
                    search: "",
                    from_date: "",
                    to_date: currentDate,
                    per_page: 10,
                    order_id: orderId,
                    currentPage: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                    field: "order_number",
                    order_by: "desc",
                },
            };
        },
        computed: {
            isPlantWide() {
                if (this.meta.order_id) {
                    return false;
                }
                return true;
            },
            listApiUri() {
                if (this.isPlantWide) {
                    return "paginateSAPPlantOrderEquipments";
                }
                return "paginateSAPOrderEquipments";
            },
            selectedEquipmentTitle() {
                if (!this.selectedEquipment) {
                    return "Attachments";
                }
                let equipmentNumber = "";
                let orderNumber = "";
                if (this.selectedEquipment.equipment_number) {
                    equipmentNumber = this.selectedEquipment.equipment_number;
                }
                if (this.selectedEquipment.order_number) {
                    orderNumber = this.selectedEquipment.order_number;
                }
                return "Attachments - " + equipmentNumber + " (Order: " + orderNumber + ")";
            },
            hasNoAttachments() {
                if (!this.selectedEquipment) {
                    return true;
                }
                if (!this.selectedEquipment.order_attachments) {
                    return true;
                }
                if (this.selectedEquipment.order_attachments.length === 0) {
                    return true;
                }
                return false;
            },
        },
        mounted() {
            this.$store.commit("setModule", "SAPEquipmentLogs");
            this.index();
        },
        methods: {
            buildPayload() {
                const payload = {
                    page: this.meta.currentPage,
                    search: this.meta.search,
                    per_page: this.meta.per_page,
                    field: this.meta.field,
                    order_by: this.meta.order_by,
                };

                if (this.isPlantWide) {
                    payload.to_date = this.meta.to_date;
                    if (this.meta.from_date) {
                        payload.from_date = this.meta.from_date;
                    }
                } else {
                    payload.order_id = this.meta.order_id;
                }

                return payload;
            },

            validateDates() {
                let vm = this;

                if (!vm.isPlantWide) {
                    return true;
                }

                vm.errors = {};

                if (!vm.meta.to_date) {
                    vm.errors.to_date = ["To Date is required."];
                }
                if (vm.meta.from_date && vm.meta.to_date) {
                    if (new Date(vm.meta.from_date) > new Date(vm.meta.to_date)) {
                        vm.$store.dispatch("error", "From Date cannot be greater than To Date.");
                        return false;
                    }
                }
                if (vm.errors.to_date) {
                    return false;
                }
                return true;
            },

            index() {
                const vm = this;

                if (!vm.validateDates()) {
                    return;
                }

                vm.$store
                    .dispatch("post", {
                        uri: vm.listApiUri,
                        data: vm.buildPayload(),
                    })
                    .then((response) => {
                        vm.sap_logs = response.data.data;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        if (vm.meta.lastPage >= 3) {
                            vm.meta.maxPage = 3;
                        } else {
                            vm.meta.maxPage = vm.meta.lastPage;
                        }
                    })
                    .catch((err) => {
                        let msg = "Failed to load data";
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.message) {
                                    msg = err.response.data.message;
                                }
                            }
                        }
                        vm.$store.dispatch("error", msg);
                    });
            },

            exportAllExcel() {
                const vm = this;
                const user = vm.$store.getters.user;

                if (!user) {
                    vm.$store.dispatch("error", "You must be logged in to download data.");
                    return;
                }
                if (!user.token) {
                    vm.$store.dispatch("error", "You must be logged in to download data.");
                    return;
                }
                if (!vm.validateDates()) {
                    if (vm.isPlantWide) {
                        vm.$store.dispatch("error", "Please select To Date.");
                    }
                    return;
                }

                let searchValue = "";
                if (vm.meta.search) {
                    searchValue = vm.meta.search;
                }
                let fieldValue = "order_number";
                if (vm.meta.field) {
                    fieldValue = vm.meta.field;
                }
                let orderByValue = "desc";
                if (vm.meta.order_by) {
                    orderByValue = vm.meta.order_by;
                }

                const payload = {
                    search: searchValue,
                    field: fieldValue,
                    order_by: orderByValue,
                    register: "sap_order_equipment_logs",
                };

                if (vm.isPlantWide) {
                    payload.to_date = vm.meta.to_date;
                    if (vm.meta.from_date) {
                        payload.from_date = vm.meta.from_date;
                    }
                } else {
                    if (vm.meta.order_id) {
                        payload.order_id = vm.meta.order_id;
                    }
                }

                const loader = vm.$loading.show();

                vm.$store
                    .dispatch("post", {
                        uri: "downloadSAPOrderEquipmentLogsExcel",
                        data: payload,
                    })
                    .then((response) => {
                        let message = "SAP Equipment Logs Excel generation started! Please check Downloaded Reports.";
                        if (response.data) {
                            if (response.data.message) {
                                message = response.data.message;
                            }
                        }
                        vm.$store.dispatch("success", message);
                    })
                    .catch((err) => {
                        let msg = "Could not start SAP Equipment Logs download.";
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.message) {
                                    msg = err.response.data.message;
                                }
                            }
                        }
                        vm.$store.dispatch("error", msg);
                    })
                    .finally(() => {
                        loader.hide();
                    });
            },

            openAttachmentModal(equipment) {
                this.selectedEquipment = equipment;
                this.$nextTick(() => {
                    const modalElement = document.getElementById("attachmentModal");
                    const modal = new Modal(modalElement);
                    modal.show();
                });
            },

            openImageInNewTab(url) {
                window.open(url, "_blank");
            },

            onPageChange(page) {
                this.meta.currentPage = page;
                this.index();
            },

            onPerPageChange() {
                this.meta.currentPage = 1;
                this.index();
            },

            search() {
                this.meta.currentPage = 1;
                this.index();
            },

            getCheckUserName(check) {
                if (check.user && check.user.name) {
                    return check.user.name;
                }
                return '';
            },

            displayValue(value) {
                if (value) {
                    return value;
                }
                return '';
            },
        },
    };
</script>

<style scoped>
    .equipment-row {
        background-color: #e9ecef;
        font-weight: bold;
    }

    .equipment-row td:last-child {
        background-color: transparent !important;
        font-weight: normal;
    }

    .check-row {
        background-color: #f8f9fa;
    }

    .card-body {
        display: flex;
        flex-direction: column;
        height: 75vh;
        min-height: 400px;
    }

    .tabletop {
        flex-grow: 1;
        overflow-y: auto;
        overflow-x: auto;
    }

    .table thead th {
        position: sticky;
        top: 0;
        background: white;
        z-index: 10;
        box-shadow: inset 0 -1px 0 #dee2e6;
    }

    th:last-child,
    td:last-child {
        width: 180px;
        white-space: nowrap;
    }
</style>